import React from 'react'
import styles from './index.module.scss'
import { Button } from '@alifd/next'
import LiteratureMap from 'portal/views/ExteriorFacade/WordCloud/LiteratureMap'
import DataQuery from 'portal/views/ExteriorFacade/WordCloud/DataQuery'

interface TopicsProps {
  component: any,
  content: string,
  button: string,
  link: string,
}
export default function ResearchIdeas() {
  const topics: TopicsProps[] = [
    {
      component: <LiteratureMap />,
      content: '输入关键词，查看相关的研究热点图谱',
      button: '开始探索',
      link: '/apps/sdss',
    },
    {
      component: <DataQuery />,
      content: '基于公开数据集，查询感兴趣的变量数据',
      button: '开始探索',
      link: '/apps/dsp?path=/search',
    }
  ]

  function researchIdeas(props: TopicsProps) {
    const { component, content, button, link } = props
    return(
      <div className={ styles.topicsCard }>
        <div>{component}</div>
        <div style={{ position: 'absolute', left: '20%', bottom: 20 }}>
          <span>{ content }</span>
          <a href={ link } target="_blank" rel="noopener noreferrer">
            <Button style={{ height: 32, marginLeft: 82, color: '#fff' }}>{ button }</Button>
          </a>
        </div>
      </div>
    )
  }
  return (
    <div className={ styles.researchIdeas}>
      <h2>探索选题<span> Research Ideas</span></h2>
      <div data-flex="cross: center">
        { topics.map(researchIdeas) }
      </div>
    </div>
  )
}
